import type {RepositoryDataResponse} from '@github-ui/data-router-error-helpers'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {IssueViewerPage} from '@github-ui/server-persisted-queries'
import type {IssueViewerPageQuery} from '@github-ui/server-persisted-queries/types/IssueViewerPage'

import {issuesAppBuilder} from '../config/app-builder'

// RepositoryDataResponse exposes the errors array so handleRepositoryDataError can detect FORBIDDEN/SAML.
export type IssueViewerPayload = RepositoryDataResponse<IssueViewerPageQuery>

export function buildIssueViewerRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('issueViewerRoute', {
    // The canonical issue URL. `issues#show` decides which stack serves it, so this route is only
    // registered when the same flag is on.
    path: '/:owner/:repo/issues/:number',
    queries: [
      mainQuery<IssueViewerPayload>({
        // owner/repo/number are resolved from the pathname by the BFF; only the persisted-query id
        // has to be forwarded.
        queryDeps: ({pathname}) => ({pathname, searchParams: {queryId: IssueViewerPage}}),
      }),
    ],
  })
}

export const issueViewerRoute = buildIssueViewerRoute(issuesAppBuilder)
